import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api/client';
import { type ApiInvestmentListItem, type Investment, type PagedResult, toInvestment } from './types';

export const INVESTMENTS_QUERY_KEY = ['investments'] as const;

/**
 * Carrega os investimentos do Portfólio (GET /api/investments). A carteira da Vega é pequena
 * (poucas dezenas), então buscamos tudo numa página (take=200) e filtramos client-side — espelha
 * o mock e mantém a "Cap. alocado" derivável da seleção atual. Filtros server-side (Fundo/Tese/
 * Status) existem no backend e ficam para a paginação completa (follow-up, converge com E7).
 */
export function useInvestments() {
  return useQuery({
    queryKey: INVESTMENTS_QUERY_KEY,
    queryFn: () => apiFetch<PagedResult<ApiInvestmentListItem>>('/api/investments?take=200'),
    select: (page): Investment[] => page.items.map(toInvestment),
  });
}
